document.addEventListener("DOMContentLoaded", function () {
  var navigationBannerSection = document.querySelector(
    ".navigation-banner-section"
  );
  var toggleMenuButtons = document.querySelectorAll(".toggle-button");
  var navigationBanner = document.querySelector(".text-image-main__section");
  var closeMenuButtons = document.querySelectorAll(".close-button");

  function showNavigationBanner() {
    navigationBannerSection.classList.add("active");
    document.body.classList.add("active-menu");
  }

  function hideNavigationBanner() {
    navigationBannerSection.classList.remove("active");
    document.body.classList.remove("active-menu");
  }

  toggleMenuButtons.forEach(function (button) {
    button.addEventListener("click", showNavigationBanner);
  });

  closeMenuButtons.forEach(function (button) {
    button.addEventListener("click", hideNavigationBanner);
  });

  new WOW().init();
  
  if( !document.querySelector('body').classList.contains('template-index') == true){
    var targetElements = document.querySelectorAll(".navigation-banner-sticky");
    for (var i = 0; i < targetElements.length; i++) {
      targetElements[i].classList.add("header-fixed")
    }
  }
});

window.addEventListener("scroll", function () {
  var targetElements = document.querySelectorAll(".navigation-banner-sticky");

  for (var i = 0; i < targetElements.length; i++) {
    var element = targetElements[i];
    var scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Compare scrollTop with element.scrollHeight
    var elementTop =  ( element.scrollHeight + window.innerHeight/2 ) - (window.innerHeight/2)
    if (scrollTop >= elementTop) {
      element.classList.add("header-fixed");
    } else {
      //element.classList.remove("header-fixed");
    }
  }
});

jQuery(document).ready(function () {
  var $grid = jQuery(".services-section-grid").isotope({
    itemSelector: ".services-section-grid-item",
    layoutMode: "fitRows",
    transitionDuration: 0,
    hiddenStyle: {
      opacity: 0,
      transform: 'translateY(0)',
    },
    visibleStyle: {
      opacity: 1,
      transform: 'translateY(100px)',
    }
  });
  
  var $filters = jQuery(".list");
  setTimeout(function() {
    $filters.first().trigger("click");
    $filters.first().addClass("active");
  },100)

  $filters.click(function () {
    $filters.removeClass("active"); // Remove 'active' class from all filter buttons
    jQuery(this).addClass("active"); // Add 'active' class to the clicked filter button

    var $value = jQuery(this).attr("data-filter");
    $grid.isotope({ filter: "." + $value });
  });

  jQuery(".popup-modal").magnificPopup({
    type: "inline",
    preloader: false,
    removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function() {
         this.st.mainClass = this.st.el.attr('data-effect');
      }
    },
    midClick: true,
    focus: "#username",
    modal: true,
  });

  jQuery(document).on("click", ".popup-modal-dismiss", function (e) {
    e.preventDefault();
    jQuery.magnificPopup.close();
  });
  
  // Match height for product card
  jQuery('.collection .product-grid .grid__item .card__inner').matchHeight();
  jQuery('.collection .product-grid .grid__item .card__content .card__information .h5').matchHeight();

  if (jQuery('.about_people-love').length > 0) {
    jQuery('.about_people-love .multicolumn-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0683/9133/8199/files/pre-arrow.svg?v=1711539023" alt="Previous" width="47" height="36"></button>',
      nextArrow:'<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0683/9133/8199/files/next-arrow.svg?v=1711539022" alt="Next" width="47" height="36"></button>'
    });
  }

  if (jQuery('.about_team-slider').length > 0) {
    jQuery('.about_team-slider .multicolumn-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:'<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0683/9133/8199/files/arrow-left.svg?v=1711530816" alt="Previous" width="31" height="17.143"></button>',
      nextArrow:'<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0683/9133/8199/files/arrow-right.svg?v=1711530816" alt="Next" width="31" height="17.143"></button>',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false
          }
        }
      ]
    });
  }

  $("#promo-outer").hide();
  
  $("#close").on("click", function(){
    $("#promo-outer").slideUp();
    $("#promo-tab").slideDown();
  });
  
  $("#promo-tab").on("click", function(){
    $("#promo-tab").slideUp();
    $("#promo-outer").slideDown();
  });
  
  $("#promo-outer").on("click", function(){
    $(this).slideUp();
    $("#promo-tab").slideDown();
  });
});

document.addEventListener("DOMContentLoaded", (event) => {
  window.infiniteLoading = function(){
    if(window.location.href.includes("/collections/") && document.querySelector('.pagination') != null){
      window.totalPages = parseInt(document.querySelector('.pagination').getAttribute('data-total_pages'));
      window.currentPage = 2;
    
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      };
    
      const handleIntersection = async (entries, observer) => {
        entries.forEach(async entry => {
          if (entry.isIntersecting) {
            try {
              document.querySelector(".more-products-loading").classList.add("show");
              const nextUrl = window.location.href.includes('?')
                ? window.location.href + '&page=' + window.currentPage
                : window.location.href + '?page=' + window.currentPage;
    
              // console.log(nextUrl, window.currentPage);
    
              const response = await fetch(nextUrl, {
                method: 'GET',
                headers: {
                  'Content-Type': 'text/html',
                },
              });
    
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
    
              const next_page = await response.text();
    
              // Convert the HTML string to a DocumentFragment
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = next_page;
              const fragment = document.createDocumentFragment();
              while (tempDiv.firstChild) {
                fragment.appendChild(tempDiv.firstChild);
              }
    
              // Find and append content to #ProductGridContainer
              const productGridItems = fragment.querySelectorAll('#product-grid li.grid__item');
    
              // Check if there are items to append
              if (productGridItems.length > 0) {
                // Get the last existing li
                const lastLi = document.querySelectorAll('#product-grid li.grid__item')[
                  document.querySelectorAll('#product-grid li.grid__item').length - 1
                ];

                var parentGrid = document.querySelector('#product-grid');
                var parentGridLi = parentGrid.children[parentGrid.children.length];
                    
                productGridItems.forEach((item) => {
                  lastLi.parentNode.insertBefore(item, parentGridLi);
                });
    
                window.currentPage = window.currentPage + 1;
                if (window.currentPage > window.totalPages) {
                  observer.disconnect();
                  document.querySelector(".more-products-loading").classList.remove("show");
                  document.querySelector(".more-products-loading").classList.add("hidden");
                }
              }
            } catch (error) {
              console.error('Fetch error:', error);
            } finally {
              // Disconnect the observer to stop further observations
              // console.log("In finally...")
              document.querySelector(".more-products-loading").classList.remove("show");
            }
          }
        });
      };
    
      const observer = new IntersectionObserver(handleIntersection, options);
    
      const paginationElement = document.querySelector(".pagination");
    
      if (paginationElement) {
        observer.observe(paginationElement);
      }
    }
    /* With Infinite loading -- End */
  }
  window.infiniteLoading();
});

jQuery(document).ready(function () {
  jQuery(".question").click(function(){
    jQuery(this).toggleClass('active');
    if(jQuery(this).hasClass('active')){
      jQuery('.answer').slideUp();
      jQuery('.question').not(this).removeClass('active');
      jQuery('.faq-inbox').removeClass('activeToggle');
      jQuery(this).addClass('active');
      jQuery(this).next('.answer').slideDown();
      jQuery(this).parent().addClass("activeToggle");
    } else {
      jQuery(this).removeClass('active');
      jQuery(this).next('.answer').slideUp();
      jQuery(this).parent().removeClass("activeToggle");
    }
  });
});

// Function to change data-src to src
function loadElement(element) {
  const dataSrc = element.getAttribute('data-src');
  if (dataSrc) {
    element.setAttribute('src', dataSrc);
    element.removeAttribute('data-src'); // Remove data-src to avoid confusion later
  }
}

// Create an IntersectionObserver instance
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      loadElement(entry.target);
      observer.unobserve(entry.target); // Stop observing once the element is loaded
    }
  });
}, {
  rootMargin: '0px', // Adjust as needed, e.g., '0px 0px -50px 0px' for preloading before fully visible
  threshold: 0.1 // Trigger when 10% of the element is in view
});

// Observe all elements with the class .play-in-viewport
document.querySelectorAll('.play-in-viewport').forEach(el => {
  observer.observe(el);
});
